export default {	
	data() {
		return {
		};
	},
	computed: {
		defaultBranding() {
			return {
				'bg': '#f1f1f1',
				'color': '#333',
				'input-bg': '#e8e8e8',
				'input-color': '#000',
				'button-bg': '#fff',
				'button-color': '#333',
				'active-bg': '#f27649',
				'active-color': '#fff',
				'highlight-color': '#f27649',
				'success-bg': '#2acc7a',
				'success-color': '#fff',
				'header-bg-from': '#f1f1f1',
				'header-bg-to': '#f1f1f1',
				'header-color': '#333',
				'error-color': '#ff4f4f'
			}
		},
		brandingVars() {
			const res = { ...this.mixNotExistingBrandingVars(this.defaultBranding, this.branding) };
			Object.keys(res).map(f => {
				if (this.branding?.JsonConfig[f]) {
					res[f] = this.branding?.JsonConfig[f];
				}
			})
			return res;
		},
		brandingStyle() {
			return Object.keys(this.brandingVars).reduce((res, item) => {
				res[`--branding-${item}`] = this.brandingVars[item];
				return res;
			}, {});
		},
		brandingStyleString() {
			return Object.keys(this.brandingStyle).map(f => `${f}: ${this.brandingStyle[f]}`).join(';');
		},
	},
	watch: {
	},
	methods: {
		mixNotExistingBrandingVars(def, existingBranding) {
			const json = existingBranding?.JsonConfig || {};
			return {
				...def,
				'header-bg-from': json['bg'] || def['header-bg-from'],
				'header-bg-to': json['bg'] || def['header-bg-to'],
				'header-color': json['color'] || def['header-color'],
			}
		},
	}
}